import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher({ className = '' }) {
  const { i18n } = useTranslation();

  const change = (lng) => {
    if (!lng) return;
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem('i18nextLng', lng);
    } catch (e) {}
    document.documentElement.lang = lng;
    // handle direction if needed in future (e.g., rtl languages)
    document.documentElement.dir = (lng === 'ar' || lng === 'he') ? 'rtl' : 'ltr';
  };

  useEffect(() => {
    const lng = i18n.language || localStorage.getItem('i18nextLng') || 'en';
    document.documentElement.lang = lng;
    document.documentElement.dir = (lng === 'ar' || lng === 'he') ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <select
      aria-label="Language selector"
      value={i18n.language || 'en'}
      onChange={(e) => change(e.target.value)}
      className={`rounded-lg px-3 py-1.5 border border-nexus-border bg-nexus-card text-sm text-nexus-text outline-none nexus-transition focus:border-nexus-accent ${className}`}
    >
      <option value="en">English</option>
      <option value="so">Somali</option>
    </select>
  );
}
